import React, {useEffect, useRef, useState} from 'react'
import './Navbar.css'
import { NavLink } from "react-router-dom";
import gsap from "gsap";
import Arrow from "../../assets/image/arrow-one.png";
import ingNav from "../../assets/image/Moendoe.png";

const Navbar = () => {
   const [colorChange, setColorchange] = useState(false);

   const changeNav = () => {
    // console.log(changeNav);
     if (window.scrollY >= 80) {
       setColorchange(true);
     } else {
       setColorchange(false);
     }
   };
  
  useEffect(() => {
    window.addEventListener("scroll", changeNav);
    return () => {
      window.removeEventListener("scroll", changeNav);
    };
  }, []);
   
  const [click, setClick] = React.useState(false);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  // bottom to top
  const circleNav = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ repeat: 100, yoyo: true });

    tl.to(circleNav.current, {
      y: -1000,
      duration: 5,
      ease: "in",
    })
      .to(circleNav.current, {
        opacity: 0,

        duration: 1,
      })
      .to(circleNav.current, {
        y: -1000,
        opacity: 0,

        duration: 1,

        onComplete: () => {
          tl.play(0);
        },
      });
  }, []);
  // bottom to top


  const circleNavSec = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ repeat: 1000, yoyo: true });

    tl.to(circleNavSec.current, {
      y: -1000,
      duration: 5,
      ease: "in",
    })
      .to(circleNavSec.current, {
        opacity: 0,

        duration: 1,
      })
      .to(circleNavSec.current, {
        y: -1000,
        opacity: 0,
        delay: 1,
        duration: 1,

        onComplete: () => {
          tl.play(0);
        },
      });
  }, []);

  return (
    <div className='container-header'>
      <nav className={`font-link ${colorChange ? "colorChange" : ""}`}>
        <span className='logo'>
          {/* M<span className='logo-second'>oendoe</span> */}
          Moendoe
        </span>
        <div className='nav_collapsable'>
          <div className='container-mobile' onClick={() => Close()}>
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className='nav-item'>
                <NavLink
                  to='/home'
                  className='nav-item-link'
                  activeClassName='navbar-link-active'
                  // onClick={click ? handleClick : null}
                >
                  <span className='nav-link'>Home</span>
                </NavLink>
              </li>

              <li className='nav-item'>
                <NavLink
                  to='/profile'
                  className='nav-item-link'
                  activeClassName='navbar-link-active'
                  // onClick={click ? handleClick : null}
                >
                  <span className='nav-link'>Profile</span>
                </NavLink>
              </li>

              <li className='nav-item'>
                <NavLink
                  to='/gallery'
                  className='nav-item-link'
                  activeClassName='navbar-link-active'
                  // onClick={click ? handleClick : null}
                >
                  <span className='nav-link'>Gallery</span>
                </NavLink>
              </li>

              <li className='nav-item'>
                <NavLink
                  to='/berita'
                  className='nav-item-link'
                  activeClassName='navbar-link-active'
                  // onClick={click ? handleClick : null}
                >
                  <span className='nav-link'>Berita</span>
                </NavLink>
              </li>

              {/* <li className='nav-item'>
                <NavLink
                  to='/berita'
                  className='nav-item-link'
                  activeClassName='navbar-link-active'
                  
                >
                  <span className='nav-link'>Gallery</span>
                </NavLink>
              </li> */}

              <li className='nav-item'>
                <NavLink
                  to='/laporan'
                  className='nav-item-link'
                  activeClassName='navbar-link-active'
                  // onClick={click ? handleClick : null}
                >
                  <span className='nav-link'>Laporan</span>
                </NavLink>
              </li>

              <li className='nav-item'>
                <NavLink
                  to='/kontak'
                  className='nav-item-link'
                  activeClassName='navbar-link-active'
                >
                  <span className='nav-link'>Kontak</span>
                </NavLink>
              </li>
              <div className='container-nav-img' ref={circleNav}>
                <img src={Arrow} alt='' srcSet='' className='img-arrow-nav' />
              </div>

              <div className='container-nav-img-top' ref={circleNavSec}>
                <img
                  src={Arrow}
                  alt=''
                  srcSet=''
                  className='img-arrow-nav-top'
                />
              </div>
            </ul>
          </div>
        </div>

        <div className='nav-icon' onClick={handleClick}>
          <i className={click ? "fa-solid fa-xmark" : "fa-solid fa-bars"}></i>
        </div>
      </nav>
    </div>
  );

  // return (
  //   <div>
  //     <div
  //       className={click ? "main-container" : ""}
  //       onClick={() => Close()}
  //     />
  //     <nav className='navbar' onClick={(e) => e.stopPropagation()}>
  //       <div className='nav-container'>
  //         <NavLink exact to='/' className='nav-logo'>
  //          Moendoe
  //           {/* <i className='fa fa-code'></i> */}
  //         </NavLink>
  //         <ul className={click ? "nav-menu active" : "nav-menu"}>
  //           <li className='nav-item'>
  //             <NavLink
  //               exact
  //               to='/home'
  //               activeClassName='active'
  //               className='nav-links'
  //               onClick={click ? handleClick : null}
  //             >
  //               Home
  //             </NavLink>
  //           </li>
  //           <li className='nav-item'>
  //             <NavLink
  //               exact
  //               to='/profile'
  //               activeClassName='active'
  //               className='nav-links'
  //               onClick={click ? handleClick : null}
  //             >
  //               Profile
  //             </NavLink>
  //           </li>
  //           <li className='nav-item'>
  //             <NavLink
  //               exact
  //               to='/berita'
  //               activeClassName='active'
  //               className='nav-links'
  //               onClick={click ? handleClick : null}
  //             >
  //               Berita
  //             </NavLink>
  //           </li>
  //           <li className='nav-item'>
  //             <NavLink
  //               exact
  //               to='/laporan'
  //               activeClassName='active'
  //               className='nav-links'
  //               onClick={click ? handleClick : null}
  //             >
  //               Laporan
  //             </NavLink>
  //           </li>
  //           <li className='nav-item'>
  //             <NavLink
  //               exact
  //               to='/kontak'
  //               activeClassName='active'
  //               className='nav-links'
  //               onClick={click ? handleClick : null}
  //             >
  //               Kontak
  //             </NavLink>
  //           </li>
  //         </ul>
  //         <div className='nav-icon' onClick={handleClick}>
  //           <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
  //         </div>
  //       </div>
  //     </nav>
  //   </div>
  // );
}


export default Navbar
